import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../axios';

export interface GlobalStats {
  totalProfit: number;
  totalTrades: number;
  totalBots: number;
  totalWin: number;
  totalLoss: number;
  [key: string]: any; // для расширяемости
}

interface GlobalStatState {
  stats: GlobalStats | null;
  loading: boolean;
  error: string | null;
}

const initialState: GlobalStatState = {
  stats: null,
  loading: false,
  error: null,
};

export const fetchGlobalStats = createAsyncThunk(
  'globalStat/fetchGlobalStats',
  async (
    params: { dateFrom?: string; dateTo?: string; allTimes?: boolean },
    thunkAPI
  ) => {
const query =
      params.allTimes
        ? '?allTimes=1'
        : params.dateFrom && params.dateTo
          ? `?dateFrom=${encodeURIComponent(params.dateFrom)}&dateTo=${encodeURIComponent(params.dateTo)}`
          : '';
    const response = await axios.get(`/global-stats${query}`, {});
    return response.data as GlobalStats;
  }
);

export const exportGlobalStatsCsv = createAsyncThunk(
  'globalStat/exportGlobalStatsCsv',
  async (
    params: { dateFrom?: string; dateTo?: string; allTimes?: boolean },
    thunkAPI
  ) => {
const query =
      params.allTimes
        ? '?allTimes=1'
        : params.dateFrom && params.dateTo
          ? `?dateFrom=${encodeURIComponent(params.dateFrom)}&dateTo=${encodeURIComponent(params.dateTo)}`
          : '';
    const response = await axios.get(`/global-stats/export${query}`, {responseType: 'blob', // Для загрузки файла
    });
    // Скачиваем CSV файл
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'global-stats.csv');
    document.body.appendChild(link);
    link.click();
    link.remove();
    return true;
  }
);

const globalStatSlice = createSlice({
  name: 'globalStat',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGlobalStats.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGlobalStats.fulfilled, (state, action: PayloadAction<GlobalStats>) => {
        state.stats = action.payload;
        state.loading = false;
      })
      .addCase(fetchGlobalStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Ошибка запроса статистики';
      });
  }
});

export default globalStatSlice.reducer;
